import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M28 15H17V4a1 1 0 0 0-2 0v11H4a1 1 0 0 0 0 2h11v11a1 1 0 0 0 2 0V17h11a1 1 0 0 0 0-2" }, null, -1)
  ]))]))
}
export default { render: render }